<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="d-none d-lg-flex align-items-center py-0">
      <hm-sites v-if="['all-web-sites'].indexOf($route.name) === -1"/>
      <hm-calendar/>
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <dark-toggler class="d-none d-lg-block"/>
      <b-nav-item>
        <b-button class="mr-50" variant="outline-primary"
                  :to="{ name: 'pages-subscriptions' }">
          Upgrade
        </b-button>
      </b-nav-item>
      <user-dropdown/>
    </b-navbar-nav>
  </div>
</template>

<script>
import DarkToggler from './components/DarkToggler.vue'
import UserDropdown from './components/UserDropdown.vue'
import hmSites from './components/nurango/hmSites.vue'
import hmCalendar from './components/nurango/hmCalendar.vue'

export default {
  components: {
    DarkToggler,
    UserDropdown,
    hmSites,
    hmCalendar
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {
      }
    }
  }
}
</script>
